import styled from 'styled-components';

export const Sticky = styled.div`
    max-width: 100vw;
    height: 200vh;
    background-color: black;
    position: relative;
    @media(max-width: 680px){
        height: auto;
            }
    .titulo{ 
        z-index: 5;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
            height: 50px;
            @media(max-width: 680px){
                max-width: calc(100vw / 3);
                padding: 0 5px;
            }
        }
    }
    .iframe-sticky{
        padding-top: 70px;
        width: 100%;
        max-width: 100vw;
        height: calc(100vh - 70px);
        position: sticky;
        position: -webkit-sticky;
        top: 0;
        pointer-events: none;
        .wrapper{
            margin-top: -35px;
            width: 100%;
            max-width: 100vw;
            height: calc(100vh - 35px);
            overflow: hidden;
                @media (max-width: 680px){
                height: calc(40vh - 50px);
            }
            iframe{
                min-width: 100%;
                height: calc(100% + 70px);
            }
        }
        @media (max-width: 680px){
            height: calc(40vh - 70px);
        }
    }
    
`